import React, { useState, useEffect, Suspense, lazy } from "react"

import "./index.scss"

import Header from "../UI/Header/Header"
import Footer from "../UI/Footer/Footer"
import Tutorial from "../UI/Tutorial/Tutorial"
import LoaderPage from "../experience/loader/LoaderPage"

const Experience = lazy(() => import("../experience/Experience"))

function Home(props){
  
  const [isMounted, setIsMounted] = useState(false)
  const [activeSound, setActiveSound] = useState(true) //stato per gestire l'icona del volume
  const [clickCanvas, setClickCanvas] = useState(false) //stato per gestire il click sul canvas
  const [openFooter, setOpenFooter] = useState(false) //stato per gestire il footer nascosto
  const [targets, setTargets] = useState([]) //stato per gestire i target degli elementi interattivi
  const [isClicked, setClicked] = useState({ state: false, name: "" }) //stato per gestire il click sui target
  
  const toggleFooter = () => setOpenFooter(prev => !prev) //funzione per aprire/chiudere il footer
  
  const toggleClickCanvas = () => { //funzione per gestire il click sul canvas e chiudere vari elementi aperti
    setClickCanvas(true); 
    setOpenFooter(false);
  } 

  const toggleSound = () => setActiveSound(prev => !prev) //funzione per attivare/disattivare il volume

  const [start, setStart] = useState(false)
  
  function handleStart(){
    setStart(true)
  }

  function mount(){
    setIsMounted(true)
  }



  return (
    <>
      <LoaderPage onStart={handleStart} toggleSound={toggleSound} setMount={mount} />
      { start && <Header activeSound={activeSound} toggleSound={toggleSound} targets={targets} setClicked={setClicked} />}
      { !isMounted ? null :
        <Suspense fallback={null}>
          <Experience 
            activeSound={activeSound}
            clickCanvas={clickCanvas} 
            toggleClickCanvas={toggleClickCanvas} 
            targets={targets}
            setTargets={setTargets}
            isClicked={isClicked}
            setClicked={setClicked}
            toggleSound={toggleSound} //gestisce il volume
            handleStart={handleStart} //gestisce l'inizio dell'esperienza
            isStart={start} //stato per gestire l'inizio dell'esperienza
            />
          
          {props.children}
        </Suspense>
      }
      { start && <Tutorial /> }
      { start && <Footer activeSound={activeSound} toggleSound={toggleSound} clickCanvas={clickCanvas} openFooter={openFooter} toggleFooter={toggleFooter} />            }
    </>
  )
}


export default Home